// src/components/ui/Button.jsx
import React from 'react';
import { SIZES } from '../../utils/constants';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  type = 'button',
  disabled = false,
  loading = false,
  fullWidth = false,
  onClick,
  className = '',
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-lg border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variantClasses = {
    primary: 'bg-blue-600 border-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500',
    secondary: 'bg-gray-100 border-gray-300 text-gray-900 hover:bg-gray-200 focus:ring-gray-500',
    success: 'bg-green-600 border-green-600 text-white hover:bg-green-700 focus:ring-green-500',
    danger: 'bg-red-600 border-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    warning: 'bg-yellow-600 border-yellow-600 text-white hover:bg-yellow-700 focus:ring-yellow-500',
    outline: 'bg-transparent border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-blue-500',
    ghost: 'bg-transparent border-transparent text-blue-600 hover:bg-blue-50 focus:ring-blue-500',
    link: 'bg-transparent border-transparent text-blue-600 hover:text-blue-800 focus:ring-blue-500 p-0'
  };

  const sizeClasses = {
    xs: SIZES.BUTTON.XS,
    sm: SIZES.BUTTON.SM, 
    md: SIZES.BUTTON.MD,
    lg: SIZES.BUTTON.LG,
    xl: SIZES.BUTTON.XL
  };

  const classes = [
    baseClasses,
    variantClasses[variant] || variantClasses.primary,
    variant !== 'link' ? sizeClasses[size] : '',
    fullWidth ? 'w-full' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={classes}
      {...props}
    >
      {loading && (
        <svg
          className="animate-spin -ml-1 mr-2 h-4 w-4 text-current"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {children}
    </button>
  );
};

export default Button;